export enum ContractPriceListTypeOptions {
  STANDART = '237e0d1f-53e3-4369-99d6-0ffa0328cf7a',
  SPECIAL = '3c22fdf5-a86f-4171-8de7-72f66f2fd307',
}
